export default class GmapsCubicBezier {
  // original Belzier Curve code from nicoabie's answer to this question on StackOverflow:
  // http://stackoverflow.com/questions/5347984/letting-users-draw-curved-lines-on-a-google-map

  constructor (latlong1, latlong2, latlong3, latlong4, resolution, google, map, config) {
    this.lat1 = latlong1.lat()
    this.long1 = latlong1.lng()
    this.lat2 = latlong2.lat()
    this.long2 = latlong2.lng()
    this.lat3 = latlong3.lat()
    this.long3 = latlong3.lng()
    this.lat4 = latlong4.lat()
    this.long4 = latlong4.lng()

    var points = []

    for (var it = 0; it <= 1; it += resolution) {
      points.push(this.getBezier({
        x: this.lat1,
        y: this.long1
      }, {
        x: this.lat2,
        y: this.long2
      }, {
        x: this.lat3,
        y: this.long3
      }, {
        x: this.lat4,
        y: this.long4
      }, it))
    }

    var path = []

    for (var i = 0; i < points.length - 1; i++) {
      path.push(new google.maps.LatLng(points[i].x, points[i].y))
      path.push(new google.maps.LatLng(points[i + 1].x, points[i + 1].y, false))
    }

    var FlightLine = new google.maps.Polyline({
      path: path,
      ...config
    })

    FlightLine.setMap(map)

    return FlightLine
  }

  B1 (t) {
    return t * t * t
  }

  B2 (t) {
    return 3 * t * t * (1 - t)
  }

  B3 (t) {
    return 3 * t * (1 - t) * (1 - t)
  }

  B4 (t) {
    return (1 - t) * (1 - t) * (1 - t)
  }

  getBezier (C1, C2, C3, C4, percent) {
    let pos = {}
    pos.x = C1.x * this.B1(percent) + C2.x * this.B2(percent) + C3.x * this.B3(percent) + C4.x * this.B4(percent)
    pos.y = C1.y * this.B1(percent) + C2.y * this.B2(percent) + C3.y * this.B3(percent) + C4.y * this.B4(percent)
    return pos
  }
}
